import React from 'react';

import { Button, LinearProgress, Paper, IconButton, Typography, Box } from '@material-ui/core';

import { FastForward, NavigateNext, NavigateBefore, Delete } from '@material-ui/icons';

import { FormContext } from './context';
import HelpTooltip from './HelpTooltip';

import './SteppedForm.css';

class SteppedForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: [],
      stepDetails: {}
    };

    var apicall;
    if (this.props.localpersist && this.props.formkey && window.localStorage[this.props.formkey]) {
      apicall = JSON.parse(window.localStorage[this.props.formkey]);
    } else if (
      this.props.formkey &&
      this.props.onRestore &&
      window.localStorage[this.props.formkey]
    ) {
      apicall = this.props.onRestore(window.localStorage[this.props.formkey]);
    }

    if (apicall) {
      apicall.then((formdata) => {
        if (formdata) {
          try {
            this.props.onDataChange(formdata.data);
            this.props.onStepChange(formdata.step, this.props.step);
            this.setState({ loaded: true });
            this.props.onLoad?.();
          } catch (e) {
            console.error('Loading error', e);
          }
        }
      });
    } else {
      this.state.loaded = true;
      this.props.onLoad?.();
    }

    if (window.localStorage[this.props.formkey + '_time']) {
      this.state.startTime = parseInt(window.localStorage[this.props.formkey + '_time']);
    }
  }

  validate() {
    const errors = {};
    if (!this.state) return;

    const step = this.state.stepDetails[this.state.steps[this.props.step]];
    if (step) {
      const fields = step.fields();
      if (step.valid && !step.valid.valid()) {
        errors['_'] = step.valid.msg;
      }
      for (var id of Object.keys(fields)) {
        if (fields[id].is_valid) {
          var error = fields[id].is_valid(this.props.formdata);
          if (error !== true) errors[id] = error;
        } else {
          if (fields[id].required && !this.props.formdata[id]) errors[id] = 'required';
        }
      }
    }
    return errors;
  }

  jumpTo(id, nextStep) {
    const step = this.state.steps.indexOf(id);
    this.persist(step);
    this.props.onStepChange(step, this.props.step);
    if (nextStep) this.setState({ nextStep: nextStep });
  }

  back() {
    if (this.props.step <= 0) return 0;

    var step = this.props.step - 1;
    while (
      this.state.stepDetails[this.state.steps[step]].skip &&
      this.state.stepDetails[this.state.steps[step]].skip(this.props.formdata)
    )
      step--;
    let beforeBack =
      this.props.onBeforeBack ||
      function (step, currentStep, callback) {
        callback();
      };
    beforeBack(step, this.props.step, () => {
      this.persist(step);
      this.props.onStepChange(step, this.props.step);
    });
  }

  async next() {
    if (this.props.step >= this.state.steps.length) return this.state.steps.length - 1;

    var step;
    if (this.state.nextStep) {
      step = Math.max(0, this.state.nextStep);
    } else {
      step = Math.max(0, this.props.step + 1);
    }

    let beforeNext =
      this.props.onBeforeNext ||
      function (step, currentStep, callback) {
        callback();
      };
    while (
      this.state.stepDetails[this.state.steps[step]].skip &&
      this.state.stepDetails[this.state.steps[step]].skip(this.props.formdata)
    )
      step++;
    beforeNext(step, this.props.step, () => {
      this.setState({ nextStep: null }, () => {
        if (step >= this.state.steps.length - 1) {
          this.submit();
        } else {
          this.persist(step);
        }
        this.props.onStepChange(step, this.props.step);
      });
    });
  }

  async persist(step) {
    const pdata = {
      data: { ...this.props.formdata },
      step: step
    };

    if (this.props.localpersist && this.props.formkey) {
      window.localStorage[this.props.formkey] = JSON.stringify(pdata);
    }
    if (this.props.formkey && this.props.onPersist) {
      window.localStorage[this.props.formkey] = await this.props.onPersist(
        window.localStorage[this.props.formkey],
        pdata
      );
    }
    window.localStorage[this.props.formkey + '_time'] = new Date().getTime();
  }

  submit() {
    const finish = () => {
      if (this.props.formkey && !this.props.preserveAfterSubmit) {
        delete window.localStorage[this.props.formkey];
      }
      this.setState({ submitting: false });
    };

    const fail = (e) => {
      console.log(e);
      this.setState({ submitting: false, submitError: true });
    };

    this.setState({ submitting: true });

    return new Promise((res, rej) => {
      try {
        const p = this.props.onSubmit();
        if (p.then) {
          p.then(() => {
            finish();
            return res();
          }).catch((err) => {
            fail(err);
          });
        } else {
          finish();
        }
      } catch (e) {
        fail(e);
      }
    });
  }

  rerender() {
    this.setState({
      rerender: this.state.rerender ? this.state.rerender + 1 : 0
    });
  }

  getFormSchema() {
    const data = {};
    this.state.steps.map((step) => {
      step = this.state.stepDetails[step];
      console.log(step.title);
      data[step.title()] = [];
      if (step.fields) {
        const fields = step.fields();
        Object.keys(fields).map((key) => data[step.title()].push(fields[key].label));
      }
      return data;
    });
    return data;
  }

  render() {
    var {
      step,
      formdata,
      onReset,
      onBeforeNext,
      onBeforeBack,
      onStepChange,
      onDataChange,
      onPersist,
      onRestore,
      loadContent,
      className,
      preserveAfterSubmit,
      debug,
      ...props
    } = this.props;

    if (step < 0) step = 0;

    const stepdata = this.state.stepDetails[this.state.steps[step]];
    // console.log('stepdata', formdata)
    const steptitle = stepdata && stepdata.title ? stepdata.title() : '\u00A0';
    const validation = this.validate();

    const laststep = 'done';

    if (!this.state.loaded && loadContent) {
      return loadContent(this.state.startTime);
    }

    if (debug) {
      console.log(JSON.stringify(this.getFormSchema()));
    }

    return (
      <>
        <Box
          className={
            className + ' SteppedForm step-' + (step + 1) + (stepdata ? ' step-' + stepdata.id : '')
          }>
          <Paper variant="outlined" {...props}>
            <Box className="formHeader">
              <Box className="actions-left">
                {step > 0 && stepdata && stepdata.id !== laststep ? (
                  <Button onClick={() => this.back()} startIcon={<NavigateBefore />}>
                    Back
                  </Button>
                ) : (
                  ''
                )}
                <Typography variant="h2" className="stepNumber">
                  Step {step + 1}
                </Typography>
              </Box>

              {/* this.props.header ? this.props.header(steptitle) : steptitle */}
              <Box>
                {false && formdata && formdata.visitedSummary ? (
                  <IconButton
                    style={{
                      padding: '0',
                      borderRadius: '20px',
                      border: '1px solid'
                    }}
                    color="primary"
                    component="span"
                    onClick={() => this.jumpTo('summary')}>
                    <FastForward />
                  </IconButton>
                ) : (
                  ''
                )}
              </Box>
              <Box className="actions-right">
                <Typography variant="h2" className="stepTitle">
                  {this.props.header ? this.props.header(steptitle) : steptitle}
                </Typography>
                {step > 0 && stepdata && stepdata.id !== laststep ? (
                  <>
                    {stepdata && stepdata.actions ? stepdata.actions : null}
                    <Button onClick={() => onReset()} startIcon={<Delete />}>
                      Reset
                    </Button>
                  </>
                ) : (
                  ''
                )}
              </Box>
            </Box>

            <LinearProgress
              color="primary"
              className={step + 1 >= this.state.steps.length ? 'complete' : ''}
              variant="determinate"
              value={Math.ceil(((step + 1) / this.state.steps.length) * 100)}
            />

            {this.state.submitting ? (
              this.props.submitting ? (
                this.props.submitting
              ) : (
                <p>Submitting...</p>
              )
            ) : (
              ''
            )}
            {this.state.submitError ? (
              this.props.error ? (
                this.props.error
              ) : (
                <>
                  <h3>Error Submitting Form Response</h3>
                  <p>
                    There was an error submitting your response. Your response has been preserved;
                    please refresh, and try submitting again in a few minutes.
                  </p>
                </>
              )
            ) : (
              ''
            )}

            {!this.state.submitting && !this.state.submitError ? (
              <FormContext.Provider
                value={{
                  changeData: onDataChange,
                  formdata: formdata,
                  current_step: stepdata,
                  validation_errors: validation,
                  add_step: (step) => {
                    this.setState((state, props) => {
                      const newsteps = [...state.steps];
                      if (state.steps.indexOf(step.id) < 0) newsteps.push(step.id);
                      return {
                        ...state,
                        steps: [...newsteps],
                        stepDetails: {
                          ...state.stepDetails,
                          [step.id]: {
                            id: step.id,
                            title: step.getTitle,
                            next: step.nonext ? false : true,
                            nextText: step.nextText ? step.nextText : 'Next',
                            skip: step.skip,
                            actions: step.actions,
                            valid: step.valid,
                            parent: step.parent,
                            fields: () => step.getFieldData()
                          }
                        }
                      };
                    });
                  },
                  validate: () => this.validate(),
                  next: () => this.next(),
                  rerender: () => this.rerender(),
                  debug: debug
                }}>
                {this.props.children}

                <Box className="formactions">
                  {stepdata && stepdata.next ? (
                    validation && Object.keys(validation).length > 0 ? (
                      <HelpTooltip
                        placement="top"
                        title={
                          <>
                            The following fields need to be fixed:
                            <ul>
                              {Object.keys(validation).map((f) => (
                                <li key={f}>
                                  {f !== '_' ? <strong>{stepdata.fields()[f].label}: </strong> : ''}
                                  {validation[f]}
                                </li>
                              ))}
                            </ul>
                          </>
                        }>
                        <span className="tooltipWrapper">
                          <Button
                            className="ok"
                            color="primary"
                            variant="contained"
                            disabled={true}
                            endIcon={<NavigateNext />}>
                            {stepdata.nextText}
                          </Button>
                        </span>
                      </HelpTooltip>
                    ) : (
                      <Button
                        className="ok"
                        color="primary"
                        variant="contained"
                        onClick={() => this.next()}
                        endIcon={<NavigateNext />}>
                        {stepdata.nextText}
                      </Button>
                    )
                  ) : (
                    ''
                  )}
                </Box>
              </FormContext.Provider>
            ) : (
              ''
            )}
          </Paper>
        </Box>
      </>
    );
  }
}

export default SteppedForm;
